<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>任务提示管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="上架APP"
                        prop="app_type">
            <el-select v-model="search.app_type"
                       clearable
                       placeholder="全部">
              <el-option v-for="item in appTypeOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提示名称"
                        prop="title_keyword">
            <el-input placeholder="请输入通知名称/ID搜索"
                      clearable
                      v-model="search.title_keyword" />
          </el-form-item>
          <el-form-item label="项目"
                        prop="project_keyword">
            <el-input placeholder="请输入项目名称/ID搜索"
                      clearable
                      v-model="search.project_keyword" />
          </el-form-item>
          <el-form-item label="分步模板"
                        prop="template_keyword">
            <el-input placeholder="请输入模板名称/ID搜索"
                      clearable
                      v-model="search.template_keyword" />
          </el-form-item>
          <el-form-item label="创建人"
                        prop="adminid">
              <remote-select
                class="width-max"
                clearable
                id-key="id"
                keyword-key="name"
                label-key="name"
                value-key="id"
                placeholder="请输入创建人"
                v-model="search.adminid"
                :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status_lists: [1, 2]}))"
                :find-request="getPlatformUsersDetail">
              </remote-select>
            </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/task-notice/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">新建任务提示
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="90" />
        <el-table-column prop="app_type"
                         label="上架APP"
                         :formatter="formatAppType"
                         min-width="90" />
        <el-table-column prop="title"
                         label="提示名称"
                         min-width="120" />
        <el-table-column prop="project_name"
                         label="项目"
                         width="190" />
        <el-table-column prop="template_title"
                         label="分步模板"
                         width="190" />
        <el-table-column prop="notice_type"
                         label="提示类型"
                         :formatter="formatNoticeType"
                         width="190" />
        <el-table-column prop="adminname"
                         label="创建人"
                         width="190" />
        <el-table-column prop="updated_at"
                         label="更新日期"
                         width="190" />
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="`/task-notice/detail/${scope.row.id}`">
                <el-button size="mini">预览</el-button>
              </router-link>
              <component :is="scope.row.is_online ? 'span' : 'router-link'" :to="`/task-notice/update/${scope.row.id}`">
                <el-button size="mini"
                           :disabled="scope.row.is_online"
                           type="primary">编辑
                </el-button>
              </component>
              <el-button type="primary"
                         v-if="scope.row.is_online === false"
                         size="mini"
                         @click="onOnLine(scope.row.id)">发布
              </el-button>
              <el-button type="info"
                         v-if="scope.row.is_online === true"
                         size="mini"
                         @click="onOffLine(scope.row.id)">下线
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../task-notice.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'
import { appTypeOptions, getAppTypeLabel } from '@utils/appType'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      appTypeOptions,
      search: {
        app_type: null,
        title_keyword: null,
        project_keyword: null,
        template_keyword: null,
        adminid: null,
      },
      searchFieldType: {
        adminid: Number,
        app_type: Number,
      },
      exportHeader: [
        {
          key: 'id',
          text: '任务提示ID',
        },
        {
          key: 'name',
          text: '任务提示名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
      noticeTypes: [
        {
          value: 1,
          label: '文字',
        },
        {
          value: 2,
          label: '图片',
        },
        {
          value: 3,
          label: '图文',
        }
      ]
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([
      'getPlatformUsersIndex',
      'getPlatformUsersDetail',
    ]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getTaskNoticeTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportTaskNoticeData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onDelete (index, rows) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deleteTaskNoticeData', {id: rows[index].id}).then(() => {
          this.$message.success('删除成功')
          rows.splice(index, 1)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    onOnLine (id) {
      request.common('setOnlineTaskNoticeData', {id, is_online: true}).then(() => {
        this.$message.success('操作成功！')
        this.onRefresh()
      })
    },
    onOffLine (id) {
      request.common('setOnlineTaskNoticeData', {id, is_online: false}).then(() => {
        this.$message.success('操作成功！')
        this.onRefresh()
      })
    },
    formatAppType (row, column, cellValue) {
      return getAppTypeLabel(cellValue) || '-'
    },
    formatNoticeType (row, column, cellValue) {
      for (let i in this.noticeTypes) {
        if (this.noticeTypes[i].value * 1 === cellValue * 1) {
          return this.noticeTypes[i].label
        }
      }
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/task-notice/pages/TaskNoticeTable.vue